import { createSelector } from "reselect";

import { getCurrentSale } from "./currentSale";
import { selectTradingTermIdsByBillingSettingsIdLookup } from "./indexes";
import { createLookupCombiner, createLookupSelectors } from "./lib";
import { getBusinesses, getTradingTerms } from "./root";

export const [
  selectAllTradingTermsByBillingSettingsIdLookup,
  getAllTradingTermsByBillingSettingsId,
] = createLookupSelectors(
  [selectTradingTermIdsByBillingSettingsIdLookup, getTradingTerms],
  createLookupCombiner((tradingTermsIds, tradingTermsByIdLookup) =>
    tradingTermsIds.map(tradingTermId => tradingTermsByIdLookup[tradingTermId]),
  ),
);

export const [
  selectDeploymentTradingTermsByBillingSettingsIdLookup,
  getDeploymentTradingTermsByBillingSettingsId,
] = createLookupSelectors(
  [selectTradingTermIdsByBillingSettingsIdLookup, getTradingTerms],
  createLookupCombiner(
    (tradingTermsIds, tradingTermsByIdLookup) =>
      tradingTermsIds
        .map(tradingTermId => tradingTermsByIdLookup[tradingTermId])
        .filter(term => !term.businessId), // Only include terms with no businessId
  ),
);

export const getCurrentDefaultTradingTerms = createSelector(
  [getCurrentSale, getTradingTerms],
  (currentSale, tradingTermsLookup) => {
    // Get the relevant trading terms for this sale.

    let termForSaleTypeAndSpecies = null;
    let termForSaleType = null;
    let termForDeployment = null;

    const saleSubType = currentSale.sale_sub_type_id;
    const speciesId = currentSale.species_id;
    const saleType = currentSale.sale_type;

    //  Check if we have specific terms for this sale sub type
    Object.values(tradingTermsLookup).forEach(term => {
      // for term in self.deployment.trading_terms.all():
      if (saleSubType && term.saleSubTypeId === saleSubType) {
        // We aren't going to do better than this, so return early.
        return term;
      }

      if (term.saleType === saleType) {
        if (term.speciesId === speciesId) {
          termForSaleTypeAndSpecies = term;
        } else {
          termForSaleType = term;
        }
      }

      if (!term.saleSubType && !term.species && !term.saleType) {
        termForDeployment = term;
      }
    });

    return termForSaleTypeAndSpecies || termForSaleType || termForDeployment;
  },
);
export const getBusinessTradingTermsById = createSelector(
  [getBusinesses, getTradingTerms],
  (businesses, tradingTermsLookup) => {
    return Object.values(businesses).reduce((acc, { id: businessId }) => {
      acc[businessId] = Object.values(tradingTermsLookup).filter(
        term => term.businessId === businessId,
      );
      return acc;
    }, {});
  },
);

export const selectBusinessTradingTermsByIdLookup = createSelector(
  [getBusinessTradingTermsById],
  businessTradingTermsById => {
    return Object.keys(businessTradingTermsById).reduce((acc, businessId) => {
      acc[businessId] = businessTradingTermsById[businessId];
      return acc;
    }, {});
  },
);
